import React from 'react';
import { Link } from 'react-router-dom';

const SUPPORT_EMAIL = 'subbuhsrlayout@gmail.com';

const FAQS = [
  {
    q: 'How do I clear a level?',
    a: 'Every board is solved with exactly one tap. Study the tile hit-counts, locks, and hardened cores, then tap the tile you think will trigger a full chain reaction. If tiles remain when the chain stops, tap Retry for a fresh attempt.',
  },
  {
    q: 'What are Gold Coins, Quantum Shards, Galaxy Keys, Research Points, and Time Pods?',
    a: 'These are in-game reward currencies you earn by clearing levels and daily play. They have no real-world value and can’t be exchanged for cash or transferred between accounts.',
  },
  {
    q: 'Will my progress sync across devices?',
    a: 'Yes, once you create an account (email/password or Google) and sign in. Guest progress saved only on-device will not carry over automatically — sign in first to keep it synced.',
  },
  {
    q: 'I found a bug or a level that seems unsolvable. What do I do?',
    a: 'Please email us the level name/number and a short description (or screenshot) so we can take a look — see the contact section below.',
  },
  {
    q: 'How do I delete my account and data?',
    a: 'Email us from the address on your account and we’ll delete your account, reward balances, and progress within a reasonable time. See our Privacy Policy for details.',
  },
  {
    q: 'Where can I download the app?',
    a: 'Visit the Download page for Android and iOS links.',
  },
];

export default function Support() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Help</span>
        <h1 className="page-title section-gap">Support</h1>
        <p className="page-subtitle">Answers to common questions, plus how to reach us directly.</p>

        <div className="mt-8 space-y-4">
          {FAQS.map((f) => (
            <details key={f.q} className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
              <summary className="cursor-pointer list-none text-base font-black text-slate-900 marker:content-none">
                <span className="flex items-center justify-between gap-3">
                  {f.q}
                  <span className="shrink-0 text-slate-400 transition group-open:rotate-45">＋</span>
                </span>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{f.a}</p>
            </details>
          ))}
        </div>

        <section className="mt-10 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
          <h2 className="text-base font-black text-slate-900">Still need help?</h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">
            Email us and we&apos;ll get back to you as soon as we can. Please include your account email and,
            if it&apos;s a gameplay issue, the level name or number.
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="btn btn-primary mt-4">
            ✉️ Email {SUPPORT_EMAIL}
          </a>
        </section>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
